import * as types from './types'
export default {
  [types.SET_TECH_BUSINESSES](state, data) {
    if (data !== undefined && data !== null) {
      state.techBusinesses = data
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/config-settings/mutations.js